
<div class="search-container">
  <div class="section">
    <mat-card>
      <mat-card-header>
        <div class="page-title" translate>DASHBOARD.SEARCH-WIDGET.PLATE-DATA</div>
      </mat-card-header>
      <div class="dashboard-search--container">
        <form [formGroup]="searchForm" class="dashboard-search--container">

          <div class="dashboard-search--section dashboard-search--insert-data-section">
            <!-- palte type -->
            <div class="dashboard-search--input dashboard-search--flex-item">
              <grid-dropdown
                class="dashboard-search--input_full"
                [options]="plateTypeConfigs.options"
                option-label="label"
                option-value="value"
                [placeholder]="plateTypeConfigs.placeholder"
                [id]="plateTypeConfigs.formControlName"
                [isError]="
                  plateTypeConfigs.form.touched &&
                  plateTypeConfigs.form.get(plateTypeConfigs.formControlName)
                    ?.invalid
                "
                isPositionAbsolute="true"
                (valueChange)="setValue($event, plateTypeConfigs)"
                [value]="
                  plateTypeConfigs.form.get(plateTypeConfigs.formControlName)?.value
                "
              >
                <span slot="description">{{
                  plateTypeConfigs.slots?.description || "" | translate
                }}</span>
              </grid-dropdown>
            </div>
            <!-- vehicle type -->
            <div class="dashboard-search--input dashboard-search--flex-item">
              <grid-dropdown
                class="dashboard-search--input_full"
                [slot]="vehicleTypeConfigs.slots"
                [options]="vehicleTypeConfigs.options"
                isPositionAbsolute="true"
                option-label="label"
                option-value="value"
                [placeholder]="vehicleTypeConfigs.placeholder"
                [isError]="
                  vehicleTypeConfigs.form.touched &&
                  vehicleTypeConfigs.form.get(vehicleTypeConfigs.formControlName)
                    ?.invalid
                "
                [id]="vehicleTypeConfigs.formControlName"
                (valueChange)="setValue($event, vehicleTypeConfigs)"
                [value]="
                  vehicleTypeConfigs.form.get(vehicleTypeConfigs.formControlName)
                    ?.value
                "
              >
                <span slot="description">{{
                  vehicleTypeConfigs.slots?.description || "" | translate
                }}</span>
              </grid-dropdown>
            </div>
            <!-- plate -->
            <div class="dashboard-search--input dashboard-search--flex-item">
              <div class="grid-dropdown__header sc-grid-dropdown sc-grid-dropdown-s">
                <label>
                  {{ plateConfig.slots?.description || "" | translate }}
                </label>
              </div>
              <grid-input
                class="dashboard-search--input_full"
                [slot]="plateConfig.slots"
                [type]="plateConfig.type"
                [placeholder]="plateConfig.placeholder"
                [isError]="
                  plateConfig.form.get(plateConfig.formControlName)?.touched &&
                  plateConfig.form.get(plateConfig.formControlName)?.invalid
                "
                [errorMessage]="plateConfig.errorMessage"
                [id]="plateConfig.formControlName"
                (valueChange)="setValue($event, plateConfig)"
                [value]="plateConfig.form.get(plateConfig.formControlName)?.value"
              >
              </grid-input>
            </div>
          </div>
          <div
            class="dashboard-search--container dashboard-search--section dashboard-search--input"
          >
            <!-- Reset button -->
            <div class="dashboard-search--buttons-container">
              <div class="dashboard-search--flex-item">
                <grid-button
                  fullsize="true"
                  class="dashboard-search-buttons"
                  [variant]="btnType.SECONDARY_GHOST"
                  (click)="reset()"
                  >{{
                    "DASHBOARD.BUTTONS.RESET" | translate | uppercase
                  }}</grid-button
                >
              </div>
              <!-- search button -->
              <div class="dashboard-search--flex-item">
                <grid-button
                  fullsize="true"
                  class="dashboard-search-buttons dashboard-search-buttons__right"
                  [variant]="btnType.SECONDARY"
                  (click)="search()"
                  [type]="'submit'"
                  >{{
                    "DASHBOARD.BUTTONS.SEARCH" | translate | uppercase
                  }}</grid-button
                >
              </div>
            </div>
          </div>
        </form>
      </div>
    </mat-card>
  </div>
</div>

<div class="detail-container" *ngIf="showSummary">
  <div class="detail-section section">
    <h2
      class="red-heading"
      translate
      [innerHTML]="'DASHBOARD.SUMMARY.HEADER'"
    ></h2>
    <div class="summary-section row">
      <div
        class="cards-container col col-lg-6 col-md-12"
        *ngFor="
          let card of searchData?.summary
            | keyvalue : utilityService.originalOrder;
          index as i
        "
      >
        <app-summary-card
          [sectionDetails]="sectionDetails"
          [sectionTitle]="card.key"
          [sectionData]="card.value"
        ></app-summary-card>
      </div>
    </div>
  </div>
  <div class="accordion-section section">
    <h2
      class="red-heading"
      translate
      [innerHTML]="'DASHBOARD.DETAILED-DATA.HEADER'"
    ></h2>
    <div class="total-accordion-container">
    <div
      class="single-accordion"
      id="{{ card.key }}-detail-container"
      *ngFor="
        let card of searchData?.detail | keyvalue : utilityService.originalOrder
      "
      #accordionContainer
    >
      <app-detail-accordion
        [sectionTitle]="card.key"
        [sectionData]="card.value"
      >
      </app-detail-accordion>
    </div>
  </div>
  </div>
</div>

<grid-modal showCloseButton="false" #modal [isOpen]="openModal">
  <div slot="title" class="modal-title flex-space-between">
    <h2 translate>DASHBOARD.POP-UP.ATTENTION</h2>
    <grid-button
      icon="right"
      variant="tertiary-ghost"
      (click)="openModal = false"
    >
      <grid-icon slot="icon" color="grid-action-primary" name="close" size="l" />
    </grid-button>
  </div>
  <div slot="body" class="modal-body">
    <div class="errors-container" *ngFor ="let errorMessage of errorMessages">
      <p>
        <span class="strong">ERRORE SERVIZIO {{errorMessage.section | uppercase}} </span>
        <span *ngFor = "let message of errorMessage.messages; index as i">
          <span>{{message.codice && message.descrizione ? message.codice + ' ' + message.descrizione : message}}</span>
          <span *ngIf = "i < errorMessage.messages.length-1">,</span>
        </span>
      </p>
    </div>
  </div>
  <div slot="button-primary" class="button-box">
    <grid-button variant="secondary" (click)="openModal = false" translate
      >DASHBOARD.BUTTONS.OK</grid-button
    >
  </div>
</grid-modal>
